import React, { useEffect, useState } from 'react'
import RewardsHeader from './shared/RewardsHeader'
import FormBoxsm from './shared/FormBoxsm'
import IconCircle from './shared/IconCircle'
import { SlTrophy } from "react-icons/sl";
import { MdArrowForwardIos } from "react-icons/md";
import CategoryBox from './shared/CategoryBox';
import { IoCameraOutline } from "react-icons/io5";
import { MdOutlineHistory } from "react-icons/md";
import { MdOutlineLocationOn } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import toast, { Toaster } from 'react-hot-toast';
import { useLocation, useNavigate } from 'react-router-dom';
import UserService from '../services/common/user.service';

const userServiceInstance = new UserService();

function Rewords() {
  const [myrewardspoints, setMyRewards] = useState(false);
  const [reedemPoints, setReedemPoints] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [payoutStatus, setPayoutStatus] = useState("");
  const [statusCheckError, setStatusCheckError] = useState("");
  const [beneficiaries, setBeneficiaries] = useState({ bank_accounts: [], upi_accounts: [] });
  const [paymentMethod, setPaymentMethod] = useState("");
  const [beneficiaryId, setBeneficiaryId] = useState("");
  const [pointsToRedeem, setPointsToRedeem] = useState("");
  const [availablePoints, setAvailablePoints] = useState(0);
  const [isLoadingOptions, setIsLoadingOptions] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const reedem = location?.state?.reedem || false;

  useEffect(() => {
    if (reedem) {
      setMyRewards(true);
    }
  }, [reedem]);

  useEffect(() => {
    if (!myrewardspoints) return undefined;

    let isMounted = true;
    setIsLoadingOptions(true);
    setError("");

    Promise.all([
      userServiceInstance.beneficiaries(),
      userServiceInstance.userStatus()
    ]).then(([beneficiaryResponse, statusResponse]) => {
      if (!isMounted) return;
      const accountData = beneficiaryResponse.data?.data || {};
      const statusData = statusResponse.data?.data || {};
      const points = Number(statusData.available_points ?? reedemPoints ?? 0);

      setBeneficiaries({
        bank_accounts: accountData.bank_accounts || [],
        upi_accounts: accountData.upi_accounts || []
      });
      setAvailablePoints(points);
    }).catch((requestError) => {
      if (isMounted) {
        setError(requestError.response?.data?.message || "Unable to load saved payout accounts");
      }
    }).finally(() => {
      if (isMounted) setIsLoadingOptions(false);
    });

    return () => {
      isMounted = false;
    };
  }, [myrewardspoints, reedemPoints]);

  const showRewards = () => {
    setMyRewards(!myrewardspoints);
    setError("");
    setSuccess("");
  }
  const scanQr = () => {
    navigate('/user/scanqr');
  }
  const gotoRewards = () => {
    navigate('/user/points');
  }
  const handleMenuClick = () => {
    setMyRewards(true);
  }

  const getRedeemPoints = (data) => {
    setReedemPoints(data);
  }

  const notify = async () => {
    setError("");
    setSuccess("");
    setTransactionId("");
    setPayoutStatus("");
    setStatusCheckError("");

    const points = Number(pointsToRedeem);
    if (!paymentMethod || !beneficiaryId) {
      setError("Select a payout method and saved account");
      return;
    }
    if (!Number.isInteger(points) || points <= 0 || points > availablePoints) {
      setError("Enter a valid amount within your available points");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await userServiceInstance.redeemPoints({
        points_to_redeem: points,
        payment_method: paymentMethod,
        beneficiary_id: beneficiaryId
      });
      const responseData = response.data?.data || {};
      setSuccess(`${response.data?.message || "Redemption initiated"} Transaction: ${responseData.transaction_id || "submitted"}`);
      setTransactionId(responseData.transaction_id || "");
      setPayoutStatus(responseData.status || "PENDING");
      setAvailablePoints(Math.max(0, availablePoints - points));
      setPointsToRedeem("");
      toast.success("Redemption submitted");
    } catch (requestError) {
      setError(requestError.response?.data?.message || requestError.response?.data?.error || "Redemption failed");
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!transactionId) return undefined;

    let isMounted = true;
    let latestStatus = payoutStatus;
    let intervalId;

    const refreshStatus = async () => {
      if (["SUCCESS", "COMPLETED", "FAILED", "REJECTED", "REVERSED", "CANCELLED"].includes(String(latestStatus).toUpperCase())) {
        window.clearInterval(intervalId);
        return;
      }

      try {
        const response = await userServiceInstance.redemptionStatus(transactionId);
        if (!isMounted) return;
        const status = response.data?.data?.status;
        if (status) {
          latestStatus = status;
          setPayoutStatus(status);
        }
        setStatusCheckError("");
      } catch (requestError) {
        if (isMounted) setStatusCheckError("Status check temporarily unavailable. We will retry.");
      }
    };

    refreshStatus();
    intervalId = window.setInterval(refreshStatus, 10000);
    return () => {
      isMounted = false;
      window.clearInterval(intervalId);
    };
  }, [transactionId, payoutStatus]);

  useEffect(() => {
    setError("");
  }, [])

  return (
    < >
      <RewardsHeader onPointsClick={handleMenuClick} getRedeemPoints={getRedeemPoints} />
      <div className='form-wrapper'>
        <FormBoxsm>
          <Toaster />
          <div className='flex  items-center gap-4'>
            <IconCircle> <SlTrophy /> </IconCircle>
            <div> <h4>Redeem your points</h4>
              {!myrewardspoints ? <p className='redfont cursor-pointer' onClick={showRewards}>Click to Redeem</p> : <></>}
            </div>
            <div className='redfont' style={{ fontSize: "18px", marginLeft: "auto" }}>
              {!myrewardspoints ? <MdArrowForwardIos className='cursor-pointer' onClick={showRewards} /> :
                <IoIosCloseCircleOutline className='cursor-pointer' onClick={showRewards} />
              }
            </div>
          </div>
          {
            myrewardspoints &&

            <div className={`showredempoints mt-2 pb-10 ${myrewardspoints ? 'show' : 'hide'}`}>
              <div className="input-group">
                {/* <label>  Enter reward points to claim  </label> */}
                <div className='inline-flex p-2'>
                  <h3 className=''>Available points:</h3>
                  <h3 className='ps-3'>{availablePoints}</h3>
                </div>
                {isLoadingOptions && <p className='px-2'>Loading saved payout accounts...</p>}
                {!isLoadingOptions && beneficiaries.bank_accounts.length === 0 && beneficiaries.upi_accounts.length === 0 && (
                  <p className='px-2'>No verified payout accounts. Add a bank account or UPI ID first.</p>
                )}
                <div className='input-group px-2'>
                  <label htmlFor='redeem-payment-method'>Payout method</label>
                  <select
                    id='redeem-payment-method'
                    className='w-full border rounded p-2'
                    value={paymentMethod}
                    onChange={(event) => {
                      setPaymentMethod(event.target.value);
                      setBeneficiaryId("");
                    }}
                  >
                    <option value=''>Choose bank or UPI</option>
                    {beneficiaries.bank_accounts.length > 0 && <option value='bank'>Bank account</option>}
                    {beneficiaries.upi_accounts.length > 0 && <option value='upi'>UPI ID</option>}
                  </select>
                </div>
                {paymentMethod && (
                  <div className='input-group px-2'>
                    <label htmlFor='redeem-beneficiary'>Saved {paymentMethod === 'bank' ? 'bank account' : 'UPI ID'}</label>
                    <select
                      id='redeem-beneficiary'
                      className='w-full border rounded p-2'
                      value={beneficiaryId}
                      onChange={(event) => setBeneficiaryId(event.target.value)}
                    >
                      <option value=''>Choose an account</option>
                      {(paymentMethod === 'bank' ? beneficiaries.bank_accounts : beneficiaries.upi_accounts).map((account) => (
                        <option key={account.beneficiary_id} value={account.beneficiary_id} disabled={!account.beneficiary_id}>
                          {paymentMethod === 'bank'
                            ? `${account.account_holder_name} - ${account.account_number} (${account.ifsc_code})`
                            : account.upi_id}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <div className='input-group px-2'>
                  <label htmlFor='redeem-points'>Points to redeem</label>
                  <input
                    id='redeem-points'
                    type='number'
                    min='1'
                    max={availablePoints}
                    value={pointsToRedeem}
                    onChange={(event) => setPointsToRedeem(event.target.value)}
                    className='w-full border rounded p-2'
                  />
                </div>
                {error && <p className='text-red-500 px-2'>{error}</p>}
                {success && <p className='text-green-700 px-2'>{success}</p>}
                {transactionId && <p className='px-2'>Transfer status: {payoutStatus || 'Pending'}</p>}
                {statusCheckError && <p className='px-2'>{statusCheckError}</p>}
              </div>
              <div className='text-center'>
                <button
                  onClick={notify}
                  className={`redbtn ${availablePoints <= 0 || isSubmitting || isLoadingOptions ? 'disabled' : ''}`}
                  disabled={availablePoints <= 0 || isSubmitting || isLoadingOptions || beneficiaries.bank_accounts.length + beneficiaries.upi_accounts.length === 0}
                >Claim Rewards</button></div>
            </div>
          }
        </FormBoxsm>
        {!myrewardspoints &&
          <div className='grid twocol gap-5 mt-5'>
            <CategoryBox  ><div onClick={scanQr} className='flex justify-center items-center' style={{ flexDirection: "column" }}> <IconCircle> <IoCameraOutline /></IconCircle> <h4>Scan QR</h4>  </div></CategoryBox>
            <CategoryBox > <div onClick={gotoRewards} className='flex justify-center items-center' style={{ flexDirection: "column" }}>  <IconCircle> <MdOutlineHistory />  </IconCircle><h4>Reward History</h4> </div></CategoryBox>
            <CategoryBox> <div className='flex justify-center items-center' style={{ flexDirection: "column" }}>  <IconCircle> <MdOutlineLocationOn />  </IconCircle><h4>Near by Stores</h4> </div></CategoryBox>
          </div>
        }

      </div>


    </ >
  )
}

export default Rewords